import styled from 'styled-components';

import { colors } from '/css';
import formatPrice from '/lib/utils/formatPrice';
import Description from '/components/ui/typography/Description';
import Icon from '/components/ui/Icon';
import { TimeSlotType } from '/types/timeSlotType';
import ProjectType from '/types/projectType';
import OfferType from '/types/offerType';
import DraftType from '/types/draftType';
import ReservationType from '/types/ReservationType';
import { TemplateJobCart } from '/types/cartType';

interface ExtraCostType {
    net: number;
    gross: number;
    tax: number;
    for: 'evening' | 'weekend';
}

interface Props {
    resource?: ProjectType | OfferType | DraftType | TemplateJobCart;
    reservation?: ReservationType;
    extraCostType: 'net' | 'gross';
}

interface ReservationProps extends Props {
    reservation: ReservationType;
    resource?: any;
}

interface ResourceProps extends Props {
    resource: ProjectType | OfferType | DraftType | TemplateJobCart;
    reservation?: any;
}

export default function ExtraCosts({
    resource,
    reservation,
    extraCostType,
}: ReservationProps | ResourceProps) {
    // extra costs for evening / weekend hours
    const extraCosts = (() => {
        return (
            resource?.reservation?.timeSlots ||
            reservation?.timeSlots ||
            []
        )
            .filter(
                (slot: TimeSlotType) => slot.isEveningHours || slot.isWeekend
            )
            .map((slot: TimeSlotType) => ({
                ...slot.extraCost,
                for: slot.isEveningHours ? 'evening' : 'weekend',
            }));
    })();

    return (
        <>
            {extraCosts.map((cost: ExtraCostType, i: number) => (
                <StyledDescription key={i} className="extra-cost-detail">
                    <Icon
                        icon={cost.for === 'evening' ? 'moon' : 'calendar'}
                        fill={colors.grey6}
                    />
                    <span>
                        inkludert {formatPrice(cost?.[extraCostType])} i{' '}
                        {cost.for === 'evening'
                            ? 'kveldstillegg'
                            : 'helgetillegg'}
                    </span>
                </StyledDescription>
            ))}
        </>
    );
}

const StyledDescription = styled(Description)`
    display: flex;
    align-items: center;
    margin-right: 6px;
`;
